"use strict";
require('./bootstrap');
require('./Index');
